module.exports = __webpack_public_path__ + "assets/img/reminder-detail-3.1ea8f5f6.png";